interface CategoryDetails {
  title: string
  meta_description: string
  h1: string
  h2: string
  description: string
}
export const getCategoryDetails = (detail: any): CategoryDetails | undefined => {
  try {
    const res = JSON.parse(detail)
    if (typeof res === 'object' && res !== null) {
      return res
    }
  } catch (e) {
    console.error(e)
  }
}
